/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Suppression_InvalidInputs */

const en_error_suppression_invalid = /** @type {(inputs: Error_Suppression_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The address cannot be added as it is: correct the field marked.`)
};

/**
* | output |
* | --- |
* | "The address cannot be added as it is: correct the field marked." |
*
* @param {Error_Suppression_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_suppression_invalid = /** @type {((inputs?: Error_Suppression_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Suppression_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_suppression_invalid(inputs)
});